//Icon object
import React from 'react'

const arcmIcons = {}

arcmIcons.arrowLeft = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='17'
    viewBox='0 0 10 17'
    fill='none'
  >
    <path
      className='arcm-transition-all group-hover:arcm-stroke-white'
      d='M8.75 16L1.25 8.5L8.75 1'
      stroke='#3858E9'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
arcmIcons.arrowRight = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='17'
    viewBox='0 0 10 17'
    fill='none'
  >
    <path
      className='arcm-transition-all group-hover:arcm-stroke-white'
      d='M1.25 16L8.75 8.5L1.25 1'
      stroke='#3858E9'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

arcmIcons.folderSetting = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='128'
    height='129'
    viewBox='0 0 128 129'
    fill='none'
  >
    <path
      d='M111.869 17.638V63.6082H16.131V7.60499C16.131 5.35099 17.9582 3.52374 20.2122 3.52374H51.3997C53.2045 3.52374 54.9328 4.25274 56.1922 5.54499L64.0003 13.5567H107.788C110.042 13.5567 111.869 15.384 111.869 17.638Z'
      fill='#F4FEFF'
    />
    <path
      d='M111.869 36.301V91.5675C111.869 94.3303 109.63 96.5698 106.867 96.5698H21.1332C18.3705 96.5698 16.131 94.3303 16.131 91.5675V36.301C16.131 33.5383 18.3705 31.2988 21.1332 31.2988H106.867C109.63 31.2988 111.869 33.5383 111.869 36.301Z'
      fill='#C9DEF7'
    />
    <path
      d='M104.217 24.5675V31.2988H23.7832V24.5675C23.7832 22.6188 25.363 21.039 27.3117 21.039H100.688C102.637 21.039 104.217 22.6188 104.217 24.5675Z'
      fill='#F4FEFF'
    />
    <path
      d='M92.9053 91.6725C92.9053 91.0637 92.4118 90.57 91.8027 90.57H87.5805C86.9995 88.2797 86.092 86.1205 84.913 84.1412L87.9017 81.1525C88.3322 80.722 88.3322 80.024 87.9017 79.5935L80.976 72.6677C80.5455 72.2372 79.8475 72.2372 79.417 72.6677L76.4283 75.6565C74.449 74.4777 72.2897 73.57 69.9995 72.9892V68.767C69.9995 68.1582 69.506 67.6645 68.897 67.6645H59.1025C58.4938 67.6645 58 68.158 58 68.767V72.9895C55.7097 73.5705 53.5507 74.478 51.5715 75.6567L48.5827 72.668C48.1522 72.2375 47.4543 72.2375 47.0238 72.668L40.0983 79.5935C39.6678 80.024 39.6678 80.722 40.0983 81.1525L43.087 84.1412C41.9083 86.1205 41.0005 88.2795 40.4195 90.57H36.1975C35.5887 90.57 35.095 91.0635 35.095 91.6725V101.467C35.095 102.075 35.5885 102.569 36.1975 102.569H40.4198C41.0008 104.859 41.9083 107.019 43.087 108.998L40.0983 111.987C39.6678 112.417 39.6678 113.115 40.0983 113.546L47.024 120.472C47.4545 120.902 48.1525 120.902 48.583 120.472L51.5718 117.483C53.551 118.662 55.71 119.569 58.0005 120.15V124.373C58.0005 124.982 58.494 125.475 59.103 125.475H68.8975C69.5062 125.475 70 124.982 70 124.373V120.151C72.2905 119.57 74.4498 118.662 76.429 117.483L79.4177 120.472C79.8482 120.902 80.5463 120.902 80.9768 120.472L87.9023 113.546C88.3328 113.116 88.3328 112.418 87.9023 111.987L84.9135 108.998C86.0922 107.019 87 104.86 87.581 102.57H91.8033C92.412 102.57 92.9057 102.076 92.9057 101.467L92.9053 91.6725Z'
      fill='#F4FEFF'
    />
    <path
      d='M64.0003 108.187C70.4164 108.187 75.6178 102.986 75.6178 96.5698C75.6178 90.1536 70.4164 84.9523 64.0003 84.9523C57.5841 84.9523 52.3828 90.1536 52.3828 96.5698C52.3828 102.986 57.5841 108.187 64.0003 108.187Z'
      fill='#C9DEF7'
    />
    <path
      d='M107.788 12.0325H64.643L57.283 4.48075C55.7458 2.904 53.602 2 51.4 2H20.212C17.1215 2 14.6063 4.514 14.6063 7.6045V53.2767V91.5675C14.6063 95.1665 17.5348 98.0938 21.1338 98.0938H33.5708V101.466C33.5708 102.915 34.7498 104.094 36.198 104.094H39.2622C39.7505 105.699 40.396 107.253 41.1903 108.738L39.0202 110.909C37.9972 111.932 37.9972 113.597 39.0202 114.624L45.9455 121.549C46.9697 122.573 48.637 122.573 49.6613 121.549L51.831 119.379C53.316 120.174 54.8715 120.819 56.4757 121.307V124.373C56.4757 125.821 57.6548 127 59.103 127H68.8972C70.3455 127 71.5245 125.821 71.5245 124.373V121.307C73.1275 120.82 74.6828 120.175 76.1702 119.379L78.339 121.548C79.3672 122.579 81.029 122.575 82.0548 121.549L88.98 114.624C90.0083 113.596 90.0068 111.934 88.98 110.91L86.8103 108.739C87.6045 107.254 88.25 105.698 88.7383 104.094H91.8038C93.252 104.094 94.4298 102.915 94.4298 101.467V98.094H106.868C110.467 98.094 113.394 95.1667 113.394 91.5677C113.394 65.0275 113.394 45.0588 113.394 17.6385C113.394 14.5478 110.879 12.0325 107.788 12.0325ZM20.212 5.04875H51.4C52.785 5.04875 54.1333 5.618 55.1003 6.60875L62.908 14.6202C63.195 14.9155 63.5892 15.0813 64 15.0813H107.788C109.198 15.0813 110.345 16.228 110.345 17.6383V30.7992C108.209 29.4443 106.359 29.841 105.742 29.775V24.568C105.742 21.7812 103.476 19.515 100.689 19.515H27.3123C24.5255 19.515 22.2593 21.7812 22.2593 24.568V29.7747C21.6198 29.843 19.7703 29.4578 17.655 30.7992V7.6045C17.655 6.19575 18.8018 5.04875 20.212 5.04875ZM102.693 29.7747H25.308V24.568C25.308 23.4628 26.2073 22.5637 27.3123 22.5637H100.689C101.794 22.5637 102.693 23.463 102.693 24.568V29.7747ZM91.3808 101.045H87.5805C86.8825 101.045 86.274 101.518 86.1025 102.194C85.5678 104.306 84.727 106.333 83.604 108.218C83.248 108.818 83.3433 109.583 83.8363 110.076L86.5253 112.766L80.1968 119.094L77.5065 116.404C77.0122 115.91 76.2465 115.816 75.6488 116.172C73.7612 117.298 71.7343 118.138 69.6263 118.672C68.9498 118.843 68.4758 119.452 68.4758 120.15V123.951H59.5247V120.15C59.5247 119.452 59.052 118.843 58.3755 118.672C56.264 118.137 54.237 117.296 52.3517 116.173C51.7515 115.817 50.9883 115.911 50.494 116.406L47.8037 119.096L41.4753 112.766L44.1655 110.076C44.6585 109.583 44.7538 108.817 44.3978 108.218C43.2748 106.333 42.434 104.307 41.898 102.194C41.7265 101.518 41.118 101.045 40.42 101.045H36.6198V92.094H40.42C41.118 92.094 41.7265 91.6212 41.898 90.9447C42.434 88.832 43.2748 86.8062 44.3978 84.921C44.755 84.322 44.6585 83.5562 44.1655 83.0632L41.4753 80.373L47.8037 74.0445L50.494 76.7347C50.9857 77.229 51.754 77.323 52.3517 76.967C54.237 75.844 56.2627 75.0033 58.3755 74.4672C59.052 74.2957 59.5247 73.6872 59.5247 72.9893V69.189H68.4758V72.9893C68.4758 73.6872 68.9485 74.2957 69.625 74.4672C71.7378 75.0033 73.7635 75.844 75.6488 76.967C76.2465 77.323 77.0122 77.229 77.5065 76.7347L80.1968 74.0445L86.5253 80.373L83.835 83.0632C83.342 83.5562 83.2455 84.322 83.6028 84.921C84.7258 86.8062 85.5665 88.832 86.1025 90.9447C86.274 91.6212 86.8825 92.094 87.5805 92.094H91.3808V101.045ZM110.345 91.5675C110.345 93.485 108.785 95.045 106.868 95.045H94.4295V91.6722C94.4295 90.224 93.2505 89.045 91.8023 89.045H88.738C88.2498 87.4395 87.6043 85.8855 86.81 84.4003L88.9798 82.2302C90.008 81.202 90.0065 79.5402 88.9798 78.5157L82.0533 71.588C81.0278 70.565 79.3605 70.5662 78.34 71.5892L76.169 73.7592C74.684 72.965 73.1297 72.3195 71.5242 71.8313V68.767C71.5242 67.3187 70.3453 66.1397 68.897 66.1397H59.1027C57.6545 66.1397 56.4755 67.3187 56.4755 68.767V71.8313C54.8702 72.3195 53.316 72.965 51.8307 73.7592L49.6598 71.5882C48.6343 70.5652 46.967 70.5665 45.9465 71.5895L39.02 78.516C37.997 79.539 37.997 81.204 39.02 82.2305L41.19 84.4005C40.3957 85.8855 39.7503 87.441 39.262 89.0452H36.1978C34.7495 89.0452 33.5705 90.2243 33.5705 91.6725V95.0452H21.1338C19.2153 95.0452 17.655 93.4853 17.655 91.5677V54.3247V36.3013C17.655 34.3838 19.215 32.8237 21.1338 32.8237H106.868C108.785 32.8237 110.345 34.3838 110.345 36.3013V91.5675Z'
      fill='#0C76F0'
    />
    <path
      d='M64 83.4275C56.7533 83.4275 50.858 89.3225 50.858 96.5695C50.858 103.816 56.753 109.711 64 109.711C71.247 109.711 77.142 103.816 77.142 96.5695C77.142 89.3225 71.2467 83.4275 64 83.4275ZM64 106.662C58.4348 106.662 53.9067 102.134 53.9067 96.5692C53.9067 91.004 58.4348 86.476 64 86.476C69.5653 86.476 74.0932 91.004 74.0932 96.5692C74.0932 102.134 69.5653 106.662 64 106.662Z'
      fill='#0C76F0'
    />
  </svg>
)

// dashbaord icons
arcmIcons.settings = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M7.99464 3.2835C8.06998 2.83145 8.46109 2.50012 8.91938 2.50012H11.081C11.5393 2.50012 11.9304 2.83145 12.0058 3.2835L12.1837 4.35104C12.2356 4.66274 12.4439 4.92238 12.7204 5.07542C12.7822 5.10964 12.8433 5.14498 12.9037 5.18143C13.1746 5.34499 13.504 5.39584 13.8003 5.28484L14.8144 4.90494C15.2435 4.74416 15.726 4.91721 15.9552 5.3141L17.036 7.18613C17.2651 7.58302 17.1737 8.0874 16.8199 8.37867L15.983 9.06769C15.7392 9.26835 15.6184 9.57822 15.6242 9.8939C15.6249 9.92923 15.6252 9.96464 15.6252 10.0001C15.6252 10.0356 15.6249 10.071 15.6242 10.1063C15.6184 10.422 15.7392 10.7319 15.983 10.9325L16.8199 11.6216C17.1737 11.9128 17.2651 12.4172 17.036 12.8141L15.9552 14.6861C15.726 15.083 15.2435 15.2561 14.8144 15.0953L13.8003 14.7154C13.504 14.6044 13.1746 14.6552 12.9037 14.8188C12.8433 14.8553 12.7822 14.8906 12.7204 14.9248C12.4439 15.0779 12.2356 15.3375 12.1837 15.6492L12.0058 16.7167C11.9304 17.1688 11.5393 17.5001 11.081 17.5001H8.91938C8.46109 17.5001 8.06998 17.1688 7.99464 16.7167L7.81671 15.6492C7.76476 15.3375 7.55645 15.0779 7.27998 14.9248C7.21817 14.8906 7.15707 14.8553 7.09671 14.8188C6.82585 14.6553 6.4964 14.6044 6.2001 14.7154L5.18604 15.0953C4.75688 15.2561 4.27439 15.083 4.04525 14.6861L2.96443 12.8141C2.73529 12.4172 2.82666 11.9128 3.18048 11.6216L4.01744 10.9326C4.2612 10.7319 4.38203 10.422 4.37618 10.1063C4.37553 10.071 4.3752 10.0356 4.3752 10.0001C4.3752 9.96464 4.37553 9.92923 4.37618 9.89391C4.38203 9.57823 4.2612 9.26837 4.01744 9.0677L3.18048 8.37868C2.82666 8.08741 2.73529 7.58303 2.96443 7.18614L4.04525 5.31411C4.27439 4.91722 4.75688 4.74417 5.18604 4.90495L6.20009 5.28484C6.49639 5.39585 6.82583 5.345 7.0967 5.18144C7.15706 5.14499 7.21816 5.10964 7.27998 5.07542C7.55645 4.92238 7.76476 4.66274 7.81671 4.35104L7.99464 3.2835Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M12.5 10.0001C12.5 11.3808 11.3807 12.5001 10 12.5001C8.61929 12.5001 7.50001 11.3808 7.50001 10.0001C7.50001 8.61934 8.61929 7.50006 10 7.50006C11.3807 7.50006 12.5 8.61934 12.5 10.0001Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
arcmIcons.dashboard = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M1.125 3C1.125 1.96447 1.96447 1.125 3 1.125H4.875C5.91053 1.125 6.75 1.96447 6.75 3V4.875C6.75 5.91053 5.91053 6.75 4.875 6.75H3C1.96447 6.75 1.125 5.91053 1.125 4.875V3Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M1.125 11.125C1.125 10.0895 1.96447 9.25 3 9.25H4.875C5.91053 9.25 6.75 10.0895 6.75 11.125V13C6.75 14.0355 5.91053 14.875 4.875 14.875H3C1.96447 14.875 1.125 14.0355 1.125 13V11.125Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M9.25 3C9.25 1.96447 10.0895 1.125 11.125 1.125H13C14.0355 1.125 14.875 1.96447 14.875 3V4.875C14.875 5.91053 14.0355 6.75 13 6.75H11.125C10.0895 6.75 9.25 5.91053 9.25 4.875V3Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M9.25 11.125C9.25 10.0895 10.0895 9.25 11.125 9.25H13C14.0355 9.25 14.875 10.0895 14.875 11.125V13C14.875 14.0355 14.0355 14.875 13 14.875H11.125C10.0895 14.875 9.25 14.0355 9.25 13V11.125Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

arcmIcons.archiveOrders = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M16.875 6.25L16.3538 15.1101C16.2955 16.1012 15.4748 16.875 14.4821 16.875H5.51795C4.52518 16.875 3.70448 16.1012 3.64618 15.1101L3.125 6.25M8.33313 9.375H11.6665M2.8125 6.25H17.1875C17.7053 6.25 18.125 5.83027 18.125 5.3125V4.0625C18.125 3.54473 17.7053 3.125 17.1875 3.125H2.8125C2.29473 3.125 1.875 3.54473 1.875 4.0625V5.3125C1.875 5.83027 2.29473 6.25 2.8125 6.25Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

arcmIcons.exportOrders = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M16.25 11.875V9.6875C16.25 8.1342 14.9908 6.875 13.4375 6.875H12.1875C11.6697 6.875 11.25 6.45527 11.25 5.9375V4.6875C11.25 3.1342 9.9908 1.875 8.4375 1.875H6.875M7.5 11.875L10 14.375M10 14.375L12.5 11.875M10 14.375L10 9.375M8.75 1.875H4.6875C4.16973 1.875 3.75 2.29473 3.75 2.8125V17.1875C3.75 17.7053 4.16973 18.125 4.6875 18.125H15.3125C15.8303 18.125 16.25 17.7053 16.25 17.1875V9.375C16.25 5.23286 12.8921 1.875 8.75 1.875Z'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

arcmIcons.logs = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      className=' arcm-transition-all group-[.active]:arcm-stroke-[#3858e9] group-hover:arcm-stroke-[#3858e9]'
      d='M10 5.03473C8.67311 3.84713 6.92089 3.125 5 3.125C4.12341 3.125 3.28195 3.27539 2.5 3.55176V15.4268C3.28195 15.1504 4.12341 15 5 15C6.92089 15 8.67311 15.7221 10 16.9097M10 5.03473C11.3269 3.84713 13.0791 3.125 15 3.125C15.8766 3.125 16.7181 3.27539 17.5 3.55176V15.4268C16.7181 15.1504 15.8766 15 15 15C13.0791 15 11.3269 15.7221 10 16.9097M10 5.03473V16.9097'
      stroke='#1F2937'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

arcmIcons.upgrade = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M2.87689 7.125H7.5625V15H4.85001C4.52419 15.0017 4.20936 14.8822 3.96677 14.6647C3.72419 14.4472 3.57118 14.1472 3.53752 13.8231L2.87689 7.125Z'
      fill='#A34AE8'
    />
    <path
      d='M13.1231 7.125L12.4537 13.8231C12.4201 14.1472 12.2671 14.4472 12.0245 14.6647C11.7819 14.8822 11.4671 15.0017 11.1412 15H8.4375V7.125H13.1231Z'
      fill='#A34AE8'
    />
    <path
      d='M12.8125 3.18749H11.7843C11.8842 2.98308 11.9365 2.75874 11.9375 2.53124C11.9375 2.12513 11.7761 1.73566 11.489 1.44849C11.2018 1.16133 10.8123 1 10.4062 1H10.1875C9.75403 1.00032 9.32742 1.10796 8.94571 1.31332C8.56401 1.51867 8.23909 1.81535 7.99998 2.17687C7.76087 1.81535 7.43595 1.51867 7.05425 1.31332C6.67254 1.10796 6.24593 1.00032 5.81249 1L5.59374 1C5.18763 1 4.79815 1.16133 4.51098 1.44849C4.22382 1.73566 4.06249 2.12513 4.06249 2.53124C4.06343 2.75874 4.11577 2.98308 4.21562 3.18749H3.1875C2.8394 3.18749 2.50556 3.32577 2.25942 3.57191C2.01328 3.81805 1.875 4.15189 1.875 4.49999V4.93749C1.875 5.28558 2.01328 5.61942 2.25942 5.86556C2.50556 6.1117 2.8394 6.24998 3.1875 6.24998H12.8125C13.1606 6.24998 13.4944 6.1117 13.7405 5.86556C13.9867 5.61942 14.125 5.28558 14.125 4.93749V4.49999C14.125 4.15189 13.9867 3.81805 13.7405 3.57191C13.4944 3.32577 13.1606 3.18749 12.8125 3.18749ZM10.1875 1.875H10.4062C10.5803 1.875 10.7472 1.94414 10.8703 2.06721C10.9933 2.19028 11.0625 2.3572 11.0625 2.53124C11.0625 2.70529 10.9933 2.87221 10.8703 2.99528C10.7472 3.11835 10.5803 3.18749 10.4062 3.18749H8.49435C8.59129 2.81206 8.81016 2.47946 9.11661 2.2419C9.42306 2.00434 9.79973 1.87529 10.1875 1.875ZM4.93749 2.53124C4.93749 2.3572 5.00663 2.19028 5.1297 2.06721C5.25277 1.94414 5.41969 1.875 5.59374 1.875H5.81249C6.20023 1.87529 6.5769 2.00434 6.88335 2.2419C7.1898 2.47946 7.40867 2.81206 7.50561 3.18749H5.59374C5.41969 3.18749 5.25277 3.11835 5.1297 2.99528C5.00663 2.87221 4.93749 2.70529 4.93749 2.53124Z'
      fill='#C798ED'
    />
  </svg>
)

arcmIcons.archive = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M2 3C1.44772 3 1 3.44772 1 4V5C1 5.55228 1.44772 6 2 6H18C18.5523 6 19 5.55228 19 5V4C19 3.44772 18.5523 3 18 3H2Z'
      fill='#374151'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M2 7.5H18L17.1885 15.2094C17.0813 16.2273 16.223 17 15.1995 17H4.80052C3.77701 17 2.91866 16.2273 2.81151 15.2094L2 7.5ZM7 11C7 10.4477 7.44772 10 8 10H12C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H8C7.44772 12 7 11.5523 7 11Z'
      fill='#374151'
    />
  </svg>
)

arcmIcons.database = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M4.46363 3.16188C4.79054 2.45358 5.49945 2 6.27955 2H13.7202C14.5003 2 15.2092 2.45358 15.5361 3.16188L16.69 5.66188C16.7567 5.80652 16.8047 5.9534 16.8352 6.1003C16.5675 6.03476 16.2878 6 15.9999 6H3.99989C3.712 6 3.43223 6.03476 3.16455 6.10031C3.19509 5.9534 3.24303 5.80653 3.30979 5.66188L4.46363 3.16188Z'
      fill='#374151'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M2 9.5C2 8.39543 2.89543 7.5 4 7.5H16C17.1046 7.5 18 8.39543 18 9.5C18 10.6046 17.1046 11.5 16 11.5H4C2.89543 11.5 2 10.6046 2 9.5ZM15.2402 9.5C15.2402 9.08579 15.576 8.75 15.9902 8.75H16.0002C16.4144 8.75 16.7502 9.08579 16.7502 9.5V9.51C16.7502 9.92421 16.4144 10.26 16.0002 10.26H15.9902C15.576 10.26 15.2402 9.92421 15.2402 9.51V9.5ZM12.9902 8.75C12.576 8.75 12.2402 9.08579 12.2402 9.5V9.51C12.2402 9.92421 12.576 10.26 12.9902 10.26H13.0002C13.4144 10.26 13.7502 9.92421 13.7502 9.51V9.5C13.7502 9.08579 13.4144 8.75 13.0002 8.75H12.9902Z'
      fill='#374151'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M2 15C2 13.8954 2.89543 13 4 13H16C17.1046 13 18 13.8954 18 15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15ZM15.2402 15C15.2402 14.5858 15.576 14.25 15.9902 14.25H16.0002C16.4144 14.25 16.7502 14.5858 16.7502 15V15.01C16.7502 15.4242 16.4144 15.76 16.0002 15.76H15.9902C15.576 15.76 15.2402 15.4242 15.2402 15.01V15ZM12.9902 14.25C12.576 14.25 12.2402 14.5858 12.2402 15V15.01C12.2402 15.4242 12.576 15.76 12.9902 15.76H13.0002C13.4144 15.76 13.7502 15.4242 13.7502 15.01V15C13.7502 14.5858 13.4144 14.25 13.0002 14.25H12.9902Z'
      fill='#374151'
    />
  </svg>
)

arcmIcons.folder = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M3.75 3C2.7835 3 2 3.7835 2 4.75V8.01091C2.50515 7.6875 3.10568 7.5 3.75 7.5H16.25C16.8943 7.5 17.4949 7.6875 18 8.01091V6.75C18 5.7835 17.2165 5 16.25 5H11.4142C11.3479 5 11.2843 4.97366 11.2374 4.92678L9.82322 3.51256C9.49503 3.18437 9.04992 3 8.58579 3H3.75Z'
      fill='#374151'
    />
    <path
      d='M3.75 9C2.7835 9 2 9.7835 2 10.75V15.25C2 16.2165 2.7835 17 3.75 17H16.25C17.2165 17 18 16.2165 18 15.25V10.75C18 9.7835 17.2165 9 16.25 9H3.75Z'
      fill='#374151'
    />
  </svg>
)

arcmIcons.calendar = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M5.75 2C6.16421 2 6.5 2.33579 6.5 2.75V4H13.5V2.75C13.5 2.33579 13.8358 2 14.25 2C14.6642 2 15 2.33579 15 2.75V4H15.25C16.7688 4 18 5.23122 18 6.75V15.25C18 16.7688 16.7688 18 15.25 18H4.75C3.23122 18 2 16.7688 2 15.25V6.75C2 5.23122 3.23122 4 4.75 4H5V2.75C5 2.33579 5.33579 2 5.75 2ZM4.75 7.5C4.05964 7.5 3.5 8.05964 3.5 8.75V15.25C3.5 15.9404 4.05964 16.5 4.75 16.5H15.25C15.9404 16.5 16.5 15.9404 16.5 15.25V8.75C16.5 8.05964 15.9404 7.5 15.25 7.5H4.75Z'
      fill='#374151'
    />
  </svg>
)

arcmIcons.autoArchive = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15.3124 11.4236C14.5263 14.3576 11.5104 16.0988 8.57633 15.3127C7.60731 15.053 6.77027 14.5514 6.11055 13.8904L5.79901 13.5789L8.23224 13.5785C8.64646 13.5784 8.98218 13.2425 8.98211 12.8283C8.98203 12.4141 8.64619 12.0784 8.23197 12.0785L3.98854 12.0792C3.78962 12.0792 3.59887 12.1583 3.45824 12.299C3.31761 12.4397 3.23863 12.6305 3.23868 12.8294L3.23957 17.0712C3.23965 17.4854 3.57551 17.8211 3.98972 17.821C4.40394 17.821 4.73965 17.4851 4.73957 17.0709L4.73906 14.6403L5.04891 14.9501C5.88994 15.7926 6.95762 16.4318 8.18811 16.7615C11.9224 17.7621 15.7607 15.5461 16.7613 11.8118C16.8685 11.4117 16.6311 11.0005 16.231 10.8932C15.8309 10.786 15.4196 11.0235 15.3124 11.4236ZM16.5414 7.70119C16.682 7.56051 16.761 7.36971 16.761 7.17078L16.7603 2.92883C16.7602 2.51462 16.4244 2.17889 16.0102 2.17896C15.5959 2.17902 15.2602 2.51487 15.2603 2.92908L15.2607 5.35995L14.9509 5.05013C14.1099 4.20771 13.0419 3.56827 11.8116 3.23859C8.07731 2.238 4.23895 4.45407 3.23836 8.18834C3.13115 8.58844 3.36859 8.99969 3.76869 9.1069C4.16879 9.2141 4.58004 8.97667 4.68725 8.57657C5.47343 5.6425 8.48928 3.9013 11.4233 4.68748C12.3924 4.94714 13.2295 5.44881 13.8892 6.10979L14.2003 6.4209L11.7683 6.4209C11.3541 6.4209 11.0183 6.75669 11.0183 7.1709C11.0183 7.58512 11.3541 7.9209 11.7683 7.9209H16.011C16.2099 7.9209 16.4007 7.84187 16.5414 7.70119Z'
      fill='#374151'
    />
  </svg>
)

arcmIcons.checkCircle = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
      fill='#27D935'
    />
    <path
      d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
      fill='#27D935'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M3.88946 8.37696L6.55612 11.0436C6.76412 11.2522 7.10226 11.2522 7.31026 11.0436L12.1103 6.24363C12.3183 6.03563 12.3183 5.6975 12.1103 5.4895C11.9023 5.2815 11.5641 5.2815 11.3561 5.4895L6.93319 9.91243L4.64359 7.62283C4.43559 7.41483 4.09746 7.41483 3.88946 7.62283C3.68146 7.83083 3.68146 8.16896 3.88946 8.37696Z'
      fill='white'
    />
  </svg>
)

arcmIcons.aws = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='14'
    viewBox='0 0 28 14'
    fill='none'
  >
    <path
      d='M8.78455 5.08454C8.78455 5.37264 8.81518 5.60623 8.8688 5.77753C8.93007 5.94883 9.00665 6.13571 9.11388 6.33815C9.15217 6.40045 9.16749 6.46274 9.16749 6.51724C9.16749 6.59511 9.12154 6.67297 9.02197 6.75084L8.53947 7.07787C8.47054 7.12458 8.40161 7.14794 8.34034 7.14794C8.26375 7.14794 8.18716 7.10901 8.11058 7.03893C8.00335 6.92214 7.91145 6.79755 7.83486 6.67297C7.75827 6.5406 7.68168 6.39266 7.59744 6.21357C7.00005 6.92992 6.24949 7.2881 5.34576 7.2881C4.70242 7.2881 4.18928 7.10122 3.814 6.72748C3.43872 6.35373 3.24725 5.8554 3.24725 5.23248C3.24725 4.57063 3.47701 4.03337 3.9442 3.62848C4.41138 3.22358 5.03175 3.02114 5.8206 3.02114C6.081 3.02114 6.34906 3.04449 6.63243 3.08343C6.91581 3.12236 7.20684 3.18465 7.51319 3.25473V2.68632C7.51319 2.09455 7.39065 1.68187 7.15323 1.44049C6.90815 1.19911 6.49457 1.08231 5.90485 1.08231C5.63679 1.08231 5.36107 1.11346 5.0777 1.18354C4.79432 1.25362 4.51861 1.33927 4.25055 1.44828C4.12801 1.50278 4.0361 1.53393 3.98249 1.5495C3.92888 1.56507 3.89059 1.57286 3.85995 1.57286C3.75273 1.57286 3.69912 1.49499 3.69912 1.33148V0.949944C3.69912 0.825362 3.71444 0.731924 3.75273 0.677419C3.79102 0.622914 3.85995 0.568409 3.96718 0.513904C4.23523 0.373749 4.5569 0.256952 4.93218 0.163515C5.30746 0.0622914 5.70572 0.0155729 6.12695 0.0155729C7.03835 0.0155729 7.70466 0.225806 8.13355 0.646274C8.55479 1.06674 8.76923 1.70523 8.76923 2.56174V5.08454H8.78455ZM5.67508 6.26808C5.92782 6.26808 6.18822 6.22136 6.46394 6.12792C6.73965 6.03448 6.98474 5.86318 7.19152 5.62959C7.31406 5.48165 7.40597 5.31813 7.45192 5.13126C7.49787 4.94438 7.52851 4.71858 7.52851 4.45384V4.12681C7.3064 4.0723 7.06898 4.02558 6.8239 3.99444C6.57882 3.96329 6.3414 3.94772 6.10398 3.94772C5.59084 3.94772 5.21556 4.04894 4.96282 4.25918C4.71008 4.46941 4.58754 4.7653 4.58754 5.15462C4.58754 5.52058 4.67944 5.7931 4.87091 5.97998C5.05472 6.17464 5.32278 6.26808 5.67508 6.26808ZM11.8251 7.10901C11.6872 7.10901 11.5953 7.08565 11.5341 7.03115C11.4728 6.98443 11.4192 6.87542 11.3732 6.72748L9.5734 0.708565C9.52745 0.552837 9.50447 0.451613 9.50447 0.397108C9.50447 0.272525 9.56574 0.202447 9.68828 0.202447H10.4388C10.5844 0.202447 10.6839 0.225806 10.7375 0.280311C10.7988 0.32703 10.8448 0.43604 10.8907 0.583982L12.1774 5.7386L13.3722 0.583982C13.4105 0.428254 13.4564 0.32703 13.5177 0.280311C13.5789 0.233593 13.6862 0.202447 13.824 0.202447H14.4367C14.5822 0.202447 14.6818 0.225806 14.7431 0.280311C14.8044 0.32703 14.858 0.43604 14.8886 0.583982L16.0987 5.80089L17.4237 0.583982C17.4696 0.428254 17.5232 0.32703 17.5768 0.280311C17.6381 0.233593 17.7377 0.202447 17.8755 0.202447H18.5878C18.7103 0.202447 18.7793 0.264739 18.7793 0.397108C18.7793 0.43604 18.7716 0.474972 18.7639 0.521691C18.7563 0.568409 18.741 0.630701 18.7103 0.716352L16.8646 6.73526C16.8186 6.89099 16.765 6.99221 16.7037 7.03893C16.6425 7.08565 16.5429 7.1168 16.4127 7.1168H15.754C15.6085 7.1168 15.509 7.09344 15.4477 7.03893C15.3864 6.98443 15.3328 6.8832 15.3022 6.72748L14.1151 1.70523L12.9356 6.71969C12.8973 6.87542 12.8514 6.97664 12.7901 7.03115C12.7288 7.08565 12.6216 7.10901 12.4837 7.10901H11.8251ZM21.6666 7.31924C21.2684 7.31924 20.8701 7.27253 20.4872 7.17909C20.1042 7.08565 19.8055 6.98443 19.6064 6.86763C19.4839 6.79755 19.3996 6.71969 19.369 6.64961C19.3384 6.57953 19.323 6.50167 19.323 6.43159V6.03448C19.323 5.87097 19.3843 5.7931 19.4992 5.7931C19.5451 5.7931 19.5911 5.80089 19.637 5.81646C19.683 5.83204 19.7519 5.86318 19.8285 5.89433C20.0889 6.01112 20.3723 6.10456 20.671 6.16685C20.9773 6.22914 21.276 6.26029 21.5824 6.26029C22.0649 6.26029 22.4402 6.17464 22.7006 6.00334C22.961 5.83204 23.0988 5.58287 23.0988 5.26363C23.0988 5.04561 23.0299 4.86652 22.892 4.71858C22.7542 4.57063 22.4938 4.43827 22.1185 4.31368L21.008 3.96329C20.4489 3.78421 20.0353 3.51947 19.7826 3.16908C19.5298 2.82647 19.3996 2.44494 19.3996 2.04004C19.3996 1.71301 19.4685 1.42492 19.6064 1.17575C19.7443 0.926585 19.9281 0.708565 20.1578 0.537264C20.3876 0.358176 20.648 0.225806 20.9544 0.132369C21.2607 0.0389321 21.5824 0 21.9194 0C22.0879 0 22.264 0.00778643 22.4325 0.0311457C22.6087 0.054505 22.7695 0.0856507 22.9303 0.116796C23.0835 0.155729 23.229 0.194661 23.3669 0.241379C23.5047 0.288098 23.6119 0.334817 23.6885 0.381535C23.7958 0.443827 23.8723 0.506118 23.9183 0.576196C23.9643 0.638487 23.9872 0.724138 23.9872 0.833148V1.19911C23.9872 1.36263 23.926 1.44828 23.8111 1.44828C23.7498 1.44828 23.6502 1.41713 23.52 1.35484C23.0835 1.15239 22.5933 1.05117 22.0496 1.05117C21.613 1.05117 21.2684 1.12125 21.0309 1.26919C20.7935 1.41713 20.671 1.64294 20.671 1.96218C20.671 2.1802 20.7476 2.36708 20.9007 2.51502C21.0539 2.66296 21.3373 2.8109 21.7432 2.94327L22.8308 3.29366C23.3822 3.47275 23.7804 3.72191 24.0179 4.04116C24.2553 4.3604 24.3702 4.72636 24.3702 5.13126C24.3702 5.46607 24.3012 5.76974 24.171 6.03448C24.0332 6.29922 23.8494 6.53282 23.6119 6.71969C23.3745 6.91435 23.0912 7.05451 22.7618 7.15573C22.4172 7.26474 22.0572 7.31924 21.6666 7.31924Z'
      fill='#252F3E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M23.1141 11.1035C20.5944 12.9956 16.9335 14.0001 13.7857 14.0001C9.37425 14.0001 5.39934 12.3416 2.3971 9.58517C2.15968 9.36715 2.37412 9.07127 2.6575 9.24257C5.90482 11.158 9.91036 12.3182 14.0538 12.3182C16.8492 12.3182 19.9204 11.7264 22.7465 10.5118C23.1677 10.3171 23.5277 10.7921 23.1141 11.1035Z'
      fill='#FF9900'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M24.1634 9.88881C23.8417 9.46834 22.0342 9.68636 21.2148 9.78759C20.9697 9.81873 20.9314 9.60071 21.1535 9.4372C22.5933 8.40939 24.9599 8.70527 25.2356 9.04787C25.5113 9.39826 25.159 11.8043 23.8111 12.9567C23.6043 13.1357 23.4052 13.0423 23.4971 12.8087C23.8034 12.0379 24.4851 10.3015 24.1634 9.88881Z'
      fill='#FF9900'
    />
  </svg>
)

arcmIcons.upload = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M10 13.75L10 8.125M10 8.125L12.5 10.625M10 8.125L7.5 10.625M5.625 16.25C3.55393 16.25 1.875 14.5711 1.875 12.5C1.875 10.8392 2.95463 9.43058 4.45033 8.93766C4.40087 8.67433 4.375 8.40269 4.375 8.125C4.375 5.70875 6.33375 3.75 8.75 3.75C10.776 3.75 12.4804 5.12717 12.9781 6.99646C13.2212 6.91761 13.4806 6.875 13.75 6.875C15.1307 6.875 16.25 7.99429 16.25 9.375C16.25 9.66512 16.2006 9.94369 16.1097 10.2028C17.2878 10.6504 18.125 11.7899 18.125 13.125C18.125 14.8509 16.7259 16.25 15 16.25H5.625Z'
      stroke='#1D4ED8'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

arcmIcons.warning = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15.1998 8.00005C15.1998 11.9765 11.9763 15.2 7.9998 15.2C4.02335 15.2 0.799805 11.9765 0.799805 8.00005C0.799805 4.0236 4.02335 0.800049 7.9998 0.800049C11.9763 0.800049 15.1998 4.0236 15.1998 8.00005ZM7.9998 3.50005C8.3726 3.50005 8.67481 3.80226 8.67481 4.17505V8.22505C8.67481 8.59784 8.3726 8.90005 7.9998 8.90005C7.62701 8.90005 7.3248 8.59784 7.3248 8.22505V4.17505C7.3248 3.80226 7.62701 3.50005 7.9998 3.50005ZM7.9998 12.5C8.49686 12.5 8.89981 12.0971 8.89981 11.6C8.89981 11.103 8.49686 10.7 7.9998 10.7C7.50275 10.7 7.0998 11.103 7.0998 11.6C7.0998 12.0971 7.50275 12.5 7.9998 12.5Z'
      fill='#EF4444'
    />
  </svg>
)
arcmIcons.alert = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M3.05313 15.7356C6.34162 16.0881 9.65838 16.0881 12.9469 15.7356C14.2906 15.5794 15.5797 14.2909 15.7356 12.9469C16.0881 9.65838 16.0881 6.34162 15.7356 3.05313C15.5794 1.70938 14.2909 0.420313 12.9469 0.264375C9.65838 -0.0881251 6.34162 -0.0881251 3.05313 0.264375C1.70938 0.420625 0.420313 1.70906 0.264375 3.05313C-0.0881251 6.34162 -0.0881251 9.65838 0.264375 12.9469C0.420313 14.2909 1.70906 15.5797 3.05313 15.7356Z'
      fill='#DD4247'
    />
    <path
      d='M3.76742 12.5257C8.56835 12.5257 12.4602 8.63381 12.4602 3.83319C12.4618 2.55776 12.1815 1.29774 11.6396 0.143185C8.77982 -0.0819017 5.90533 -0.0413112 3.05304 0.264435C1.70929 0.420685 0.42023 1.70912 0.264292 3.05318C-0.0450619 5.93911 -0.0829362 8.84769 0.151167 11.7407C1.28591 12.26 2.51951 12.5277 3.76742 12.5257Z'
      fill='#E55353'
    />
    <path
      d='M6.7807 3.56653C6.7807 3.2433 6.90911 2.9333 7.13767 2.70474C7.36623 2.47618 7.67622 2.34778 7.99945 2.34778C8.32268 2.34778 8.63268 2.47618 8.86124 2.70474C9.0898 2.9333 9.2182 3.2433 9.2182 3.56653V8.83653C9.2182 9.15976 9.0898 9.46976 8.86124 9.69832C8.63268 9.92688 8.32268 10.0553 7.99945 10.0553C7.67622 10.0553 7.36623 9.92688 7.13767 9.69832C6.90911 9.46976 6.7807 9.15976 6.7807 8.83653V3.56653ZM6.80101 11.779C6.83022 11.638 6.90008 11.5086 7.00199 11.4068C7.10389 11.305 7.23338 11.2353 7.37445 11.2062C7.78938 11.1421 8.21171 11.1421 8.62664 11.2062C8.76778 11.2356 8.89719 11.3058 8.99889 11.408C9.10058 11.5102 9.17009 11.6399 9.19883 11.7812C9.26299 12.1961 9.26299 12.6185 9.19883 13.0334C9.16934 13.1743 9.09924 13.3036 8.99717 13.4051C8.8951 13.5067 8.76553 13.5762 8.62445 13.605C8.4178 13.6382 8.20876 13.6544 7.99945 13.6534C7.79015 13.6543 7.58111 13.6381 7.37445 13.605C7.23308 13.576 7.10331 13.5062 7.00121 13.4042C6.89912 13.3023 6.82918 13.1726 6.80008 13.0312C6.73591 12.6163 6.73591 12.194 6.80008 11.779H6.80101Z'
      fill='white'
    />
  </svg>
)
arcmIcons.infoCircle = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='13'
    viewBox='0 0 14 13'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
      fill='#D1D5DB'
    />
  </svg>
)
arcmIcons.connections = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M7.79029 12.2097C6.5699 10.9893 6.5699 9.01068 7.79029 7.7903M12.2097 7.7903C13.4301 9.01068 13.4301 10.9893 12.2097 12.2097M6.02252 13.9775C3.82583 11.7808 3.82583 8.21923 6.02252 6.02253M13.9775 6.02253C16.1742 8.21923 16.1742 11.7808 13.9775 13.9775M4.25476 15.7452C1.08175 12.5722 1.08175 7.42777 4.25476 4.25476M15.7452 4.25476C18.9183 7.42777 18.9183 12.5722 15.7452 15.7452M10 10H10.0063V10.0063H10V10ZM10.3125 10C10.3125 10.1726 10.1726 10.3125 10 10.3125C9.82741 10.3125 9.6875 10.1726 9.6875 10C9.6875 9.82742 9.82741 9.6875 10 9.6875C10.1726 9.6875 10.3125 9.82742 10.3125 10Z'
      stroke='#3858E9'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
arcmIcons.edit = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
  >
    <path
      className=' arcm-transition-all group-hover:arcm-stroke-white'
      d='M14.0514 4.23889L15.4576 2.83265C16.0678 2.22245 17.0572 2.22245 17.6674 2.83265C18.2775 3.44284 18.2775 4.43216 17.6674 5.04235L8.81849 13.8912C8.37792 14.3318 7.83453 14.6556 7.23741 14.8335L5 15.5L5.66648 13.2626C5.84435 12.6655 6.1682 12.1221 6.60877 11.6815L14.0514 4.23889ZM14.0514 4.23889L16.25 6.43749M15 12.1667V16.125C15 17.1605 14.1605 18 13.125 18H4.375C3.33947 18 2.5 17.1605 2.5 16.125V7.37499C2.5 6.33946 3.33947 5.49999 4.375 5.49999H8.33333'
      stroke='#3858E9'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
arcmIcons.modify = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M14.0514 3.73889L15.4576 2.33265C16.0678 1.72245 17.0572 1.72245 17.6674 2.33265C18.2775 2.94284 18.2775 3.93216 17.6674 4.54235L5.69349 16.5162C5.25292 16.9568 4.70953 17.2806 4.11241 17.4585L1.875 18.125L2.54148 15.8876C2.71936 15.2905 3.04321 14.7471 3.48377 14.3065L14.0514 3.73889ZM14.0514 3.73889L16.25 5.93749'
      stroke='#3858E9'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
arcmIcons.spinning = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M3.99523 3.99523C3.40633 3.40633 3.40076 2.44063 4.07144 1.94689C5.51268 0.885882 7.22049 0.225371 9.01983 0.0481524C11.3222 -0.178615 13.6321 0.399965 15.5557 1.68531C17.4794 2.97065 18.8978 4.88323 19.5694 7.09716C20.241 9.3111 20.1242 11.6894 19.2388 13.8268C18.3534 15.9643 16.7543 17.7286 14.714 18.8192C12.6736 19.9098 10.3182 20.2592 8.04908 19.8078C5.77998 19.3565 3.73758 18.1323 2.26988 16.3439C1.12287 14.9463 0.382319 13.2716 0.113464 11.5023C-0.0116492 10.6789 0.67514 9.99997 1.50797 9.99998C2.34079 9.99998 2.99965 10.6828 3.17809 11.4963C3.41277 12.5662 3.89745 13.5731 4.60123 14.4306C5.62628 15.6797 7.05271 16.5346 8.63746 16.8499C10.2222 17.1651 11.8672 16.9211 13.2923 16.1594C14.7173 15.3977 15.8341 14.1655 16.4524 12.6727C17.0708 11.1799 17.1524 9.51887 16.6833 7.97264C16.2143 6.42641 15.2236 5.09066 13.8801 4.19296C12.5367 3.29527 10.9235 2.89119 9.31544 3.04956C8.2114 3.1583 7.1567 3.52756 6.23423 4.11814C5.53284 4.56718 4.58412 4.58412 3.99523 3.99523Z'
      fill='#bdbebf'
    >
      <animateTransform
        attributeName='transform'
        type='rotate'
        from='0 10 10'
        to='360 10 10'
        dur='2s'
        repeatCount='indefinite'
      />
    </path>
  </svg>
)
arcmIcons.SpinningAnimation = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    preserveAspectRatio='xMidYMid'
    width='120'
    height='120'
    style={{
      shapeRendering: 'auto',
      display: 'block',
      background: 'rgb(255, 255, 255)'
    }}
  >
    <g>
      <g transform='rotate(0 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-2.083333333333333s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(30 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-1.8939393939393938s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(60 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-1.7045454545454544s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(90 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-1.5151515151515151s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(120 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-1.3257575757575757s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(150 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-1.1363636363636362s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(180 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-0.9469696969696969s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(210 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-0.7575757575757576s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(240 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-0.5681818181818181s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(270 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-0.3787878787878788s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(300 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='-0.1893939393939394s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
      <g transform='rotate(330 50 50)'>
        <rect
          fill='#2492ff'
          height='12'
          width='6'
          ry='3.24'
          rx='3'
          y='24'
          x='47'
        >
          <animate
            repeatCount='indefinite'
            begin='0s'
            dur='2.272727272727273s'
            keyTimes='0;1'
            values='1;0'
            attributeName='opacity'
          />
        </rect>
      </g>
    </g>
  </svg>
)
arcmIcons.docummentsOne = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='39'
    height='42'
    viewBox='0 0 39 42'
    fill='none'
  >
    <path
      d='M30.1779 1.26883H28.2821C28.2821 0.568217 27.7142 0 27.0133 0H4.94461C4.24392 0 3.67578 0.568053 3.67578 1.26883V34.9909C3.67578 35.6917 4.24392 36.2597 4.94461 36.2597C29.0008 36.2597 27.1259 36.3337 27.5402 36.1441C27.8613 35.9971 28.1102 35.7204 28.2201 35.381H30.1778C30.1779 35.1375 30.1779 1.74435 30.1779 1.26883Z'
      fill='#60B7FF'
    />
    <path
      d='M29.6508 0H27.0132C27.714 0 28.282 0.568053 28.282 1.26883V34.9909C28.282 35.6917 27.714 36.2597 27.0132 36.2597H29.6508C30.3516 36.2597 30.9197 35.6917 30.9197 34.9909V1.26883C30.9197 0.568053 30.3516 0 29.6508 0Z'
      fill='#26A6FE'
    />
    <path
      d='M30.9197 8.69261L25.0591 2.83203H7.41512C6.44652 2.83203 5.66125 3.6173 5.66125 4.5859V35.9452C5.66125 36.053 5.67241 36.158 5.69103 36.2604H29.6509C30.3517 36.2604 30.9197 35.6923 30.9197 34.9915V8.69261Z'
      fill='#26A6FE'
    />
    <path
      d='M32.9982 9.01925L30.0244 7.16244L27.457 2.83203H9.81295C8.84435 2.83203 8.05908 3.6173 8.05908 4.5859V35.9452C8.05908 36.9138 8.84435 37.6991 9.81295 37.6991H32.9642C32.9756 37.6991 32.9868 37.6976 32.9982 37.6973V9.01925Z'
      fill='#EAF6FF'
    />
    <path
      d='M34.718 10.0922L32.0804 8.44531V35.9444C32.0804 36.913 31.2951 37.6983 30.3265 37.6983H32.9642C33.9328 37.6983 34.7181 36.913 34.7181 35.9444V10.0922H34.718Z'
      fill='#D8ECFE'
    />
    <path
      d='M29.2108 10.0931H34.718L27.4569 2.83203V8.33923C27.4569 9.30783 28.2422 10.0931 29.2108 10.0931Z'
      fill='#B3DAFE'
    />
    <path
      d='M30.5087 14.0657H12.2683C11.9179 14.0657 11.6339 13.7816 11.6339 13.4313C11.6339 13.0809 11.9179 12.7969 12.2683 12.7969H30.5087C30.8591 12.7969 31.1431 13.0809 31.1431 13.4313C31.1431 13.7816 30.8591 14.0657 30.5087 14.0657Z'
      fill='#82AEE3'
    />
    <path
      d='M30.5087 18.263H12.2683C11.9179 18.263 11.6339 17.9789 11.6339 17.6286C11.6339 17.2782 11.9179 16.9941 12.2683 16.9941H30.5087C30.8591 16.9941 31.1431 17.2782 31.1431 17.6286C31.1431 17.9789 30.8591 18.263 30.5087 18.263Z'
      fill='#82AEE3'
    />
    <path
      d='M37.4221 21.0003H36.0471C35.7527 20.4913 35.2025 20.15 34.582 20.15C33.7117 20.15 14.5079 20.15 13.2836 20.15L11.0565 16.4651H9.70644C9.4693 16.1481 9.09467 15.9561 8.69092 15.9561H1.26883C0.568053 15.9561 0 16.5242 0 17.2249V40.3079C0 41.2423 0.757459 41.9997 1.69177 41.9997H34.582C34.8614 41.9997 35.1455 41.9273 35.3967 41.7885H35.4C35.6132 41.6704 35.7976 41.5072 35.9418 41.3125H37.422L37.4221 21.0003Z'
      fill='#5D8AFC'
    />
    <path
      d='M9.81525 16.6357L11.6536 20.149H14.2913L12.4529 16.6357C12.234 16.2172 11.8009 15.9551 11.3287 15.9551H8.69104C9.1632 15.9551 9.59632 16.2172 9.81525 16.6357Z'
      fill='#3464DF'
    />
    <path
      d='M37.2197 20.1475H34.5822C35.5165 20.1475 36.2739 20.9049 36.2739 21.8392V40.3054C36.2739 41.2398 35.5165 41.9972 34.5822 41.9972H37.2197C38.1541 41.9972 38.9115 41.2397 38.9115 40.3054V21.8393C38.9115 20.9049 38.154 20.1475 37.2197 20.1475Z'
      fill='#3464DF'
    />
  </svg>
)
arcmIcons.video = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='44'
    height='36'
    viewBox='0 0 44 36'
    fill='none'
  >
    <path
      d='M33.9143 0H9.75273C8.58506 0.00129937 7.46558 0.465731 6.63991 1.2914C5.81424 2.11707 5.34981 3.23655 5.34851 4.40422V10.2497C5.34851 10.3771 5.37359 10.5032 5.42233 10.6208C5.47106 10.7385 5.5425 10.8454 5.63255 10.9354C5.72259 11.0254 5.8295 11.0969 5.94715 11.1456C6.0648 11.1943 6.1909 11.2194 6.31825 11.2194H37.3488C37.4761 11.2194 37.6022 11.1943 37.7199 11.1456C37.8375 11.0969 37.9444 11.0254 38.0345 10.9354C38.1245 10.8454 38.196 10.7385 38.2447 10.6208C38.2934 10.5032 38.3185 10.3771 38.3185 10.2497V4.40422C38.3172 3.23655 37.8528 2.11707 37.0271 1.2914C36.2014 0.465731 35.082 0.00129937 33.9143 0Z'
      fill='#0D56A9'
    />
    <path
      d='M40.6592 6.31615C40.2553 5.57141 39.6578 4.94956 38.9297 4.51628C38.2016 4.08299 37.3701 3.85435 36.5229 3.85449H7.28997C6.67202 3.85423 6.06007 3.97575 5.4891 4.21211C4.91814 4.44846 4.39935 4.79502 3.96239 5.23197C3.52542 5.66893 3.17885 6.18771 2.94249 6.75867C2.70612 7.32963 2.58459 7.94158 2.58484 8.55953V13.8658C2.58484 14.1229 2.68701 14.3696 2.86887 14.5515C3.05073 14.7333 3.29738 14.8355 3.55457 14.8355H40.2579C40.5151 14.8355 40.7617 14.7333 40.9436 14.5515C41.1255 14.3696 41.2276 14.1229 41.2276 13.8658V8.55953C41.2276 7.77612 41.0322 7.00508 40.6592 6.31615Z'
      fill='#1F72D2'
    />
    <path
      d='M5.4044 7.75781H38.2625C39.5633 7.75781 40.8107 8.27453 41.7305 9.19431C42.6503 10.1141 43.167 11.3616 43.167 12.6623V30.9749C43.167 32.2756 42.6503 33.5231 41.7305 34.4429C40.8108 35.3626 39.5633 35.8793 38.2626 35.8793H5.4044C4.10368 35.8793 2.85622 35.3626 1.93647 34.4429C1.01671 33.5231 0.5 32.2756 0.5 30.9749V12.6623C0.5 11.3616 1.01671 10.1141 1.93647 9.19437C2.85622 8.27462 4.10368 7.7579 5.4044 7.7579V7.75781Z'
      fill='#4793EB'
    />
    <path
      d='M28.5375 19.3006L19.8101 14.2618C19.3679 14.0065 18.8662 13.8721 18.3555 13.8721C17.8449 13.8721 17.3432 14.0065 16.901 14.2618C16.4587 14.5172 16.0915 14.8844 15.8362 15.3266C15.5808 15.7689 15.4464 16.2705 15.4464 16.7812V26.8587C15.4445 27.3701 15.5777 27.873 15.8326 28.3163C16.0875 28.7597 16.4549 29.1279 16.8978 29.3836C17.3407 29.6393 17.8433 29.7735 18.3547 29.7725C18.8661 29.7715 19.3682 29.6355 19.8101 29.3781L28.5375 24.3393C28.9797 24.0839 29.3469 23.7167 29.6022 23.2745C29.8575 22.8322 29.992 22.3306 29.992 21.8199C29.992 21.3093 29.8575 20.8076 29.6022 20.3654C29.3469 19.9232 28.9797 19.5559 28.5375 19.3006Z'
      fill='url(#paint0_linear_2157_6072)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2157_6072'
        x1='22.7192'
        y1='14.8199'
        x2='22.7192'
        y2='27.4569'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#EDF1F2' />
      </linearGradient>
    </defs>
  </svg>
)
arcmIcons.community = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='46'
    height='37'
    viewBox='0 0 46 37'
    fill='none'
  >
    <path
      d='M44.9888 20.6265C45.2687 13.4728 37.034 12.5189 31.7149 11.8701L24.8965 13.0064C21.1559 13.6298 28.9908 27.9872 31.7149 27.9872C34.4389 27.9872 38.7882 27.1519 41.9572 26.4518C44.7211 25.937 45.228 23.0003 44.9888 20.6265Z'
      fill='#CBA3FF'
    />
    <path
      d='M31.7154 0.5C22.2743 0.547628 22.2735 14.6126 31.7154 14.6616C41.1556 14.6139 41.1564 0.548969 31.7154 0.5Z'
      fill='#E9DCC3'
    />
    <path
      d='M13.8264 11.8701C8.50136 12.5196 0.275571 13.4736 0.552467 20.6265C0.31336 22.9995 0.819226 25.9369 3.58409 26.4514C10.2815 28.3417 17.3713 28.3417 24.0687 26.4514C26.8327 25.937 13.8264 11.8701 13.8264 11.8701Z'
      fill='#59D96B'
    />
    <path
      d='M13.8268 0.500853C4.3851 0.37243 4.38518 14.788 13.8262 14.6608C23.2673 14.7892 23.2672 0.373548 13.8268 0.500853Z'
      fill='#E9DCC3'
    />
    <path
      d='M38.2127 27.6914C37.903 18.6681 29.5158 18.6966 22.7704 17.5498C16.4833 18.3835 7.13193 19.2492 7.3281 27.6914C7.06053 30.4094 7.59874 33.8086 10.783 34.3984C18.6212 36.6125 26.9196 36.6125 34.7578 34.3984C37.9413 33.8086 38.4807 30.4103 38.2127 27.6914Z'
      fill='#00A1FF'
    />
    <path
      d='M22.7704 4.19043C11.8391 4.38206 11.8374 20.3948 22.7704 20.588C33.7009 20.3964 33.7026 4.38362 22.7704 4.19043Z'
      fill='#FDEBC9'
    />
  </svg>
)
arcmIcons.support = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='43'
    height='45'
    viewBox='0 0 43 45'
    fill='none'
  >
    <path
      d='M34.8919 30.3162V34.0669C34.8919 37.354 32.2177 40.0283 28.9304 40.0283H21.543V42.6453H28.9305C33.6608 42.6453 37.509 38.797 37.509 34.0669V30.3162H34.8919Z'
      fill='#35355E'
    />
    <path
      d='M37.5094 16.3476V20.3813H34.8924V16.3476C34.8924 8.77658 28.732 2.61701 21.161 2.61701C13.59 2.61701 7.42951 8.77658 7.42951 16.3476V20.3813H4.8125V16.3476C4.8125 7.33374 12.1462 0 21.161 0C30.1757 0 37.5094 7.33374 37.5094 16.3476Z'
      fill='#44446B'
    />
    <path
      d='M37.5086 16.3476V20.3813H34.8916V16.3476C34.8916 8.77658 28.7312 2.61701 21.1602 2.61701V0C30.1749 0 37.5086 7.33374 37.5086 16.3476Z'
      fill='#35355E'
    />
    <path
      d='M26.4158 41.3367C26.4158 43.082 24.9991 44.4902 23.2614 44.4902H19.0567C17.3147 44.4902 15.9023 43.0779 15.9023 41.3367C15.9023 39.595 17.3137 38.1824 19.0567 38.1824H23.2614C25.0034 38.1824 26.4158 39.5947 26.4158 41.3367Z'
      fill='#6092E5'
    />
    <path
      d='M26.4169 41.3367C26.4169 43.082 25.0002 44.4902 23.2625 44.4902H21.1602V38.1824H23.2625C25.0045 38.1824 26.4169 39.5947 26.4169 41.3367Z'
      fill='#3972E5'
    />
    <path
      d='M9.72726 21.006V30.0203C9.72726 31.4705 8.54699 32.6396 7.09682 32.6348C7.05721 32.6348 7.01761 32.6342 6.97783 32.6335C3.27188 32.5607 0.209189 29.6077 0.0105582 25.9064C-0.210143 21.7952 3.05789 18.3918 7.12107 18.3918C7.13031 18.3918 7.13947 18.3918 7.14863 18.3919C8.57857 18.3973 9.72726 19.5761 9.72726 21.006Z'
      fill='#6092E5'
    />
    <path
      d='M32.5938 21.006V30.0203C32.5938 31.4705 33.774 32.6396 35.2242 32.6348C35.2638 32.6348 35.3034 32.6342 35.3432 32.6335C39.0491 32.5607 42.1118 29.6077 42.3105 25.9064C42.5312 21.7952 39.2631 18.3918 35.1999 18.3918C35.1907 18.3918 35.1815 18.3918 35.1724 18.3919C33.7424 18.3973 32.5938 19.5761 32.5938 21.006Z'
      fill='#3972E5'
    />
    <path
      d='M27.2666 25.7823L21.784 31.2658C21.6122 31.4386 21.3862 31.5241 21.1603 31.5241C20.9343 31.5241 20.7084 31.4386 20.5366 31.2658L15.0539 25.7823C13.6695 24.3979 13.6695 22.1534 15.0539 20.769C16.4398 19.3849 18.6831 19.3849 20.0672 20.769L21.1603 21.8621L22.2533 20.769C23.6377 19.3846 25.8822 19.3846 27.2666 20.769C28.6468 22.1474 28.6547 24.3943 27.2666 25.7823Z'
      fill='#FF3369'
    />
    <path
      d='M27.2665 25.7823L21.7839 31.2658C21.612 31.4386 21.3861 31.5241 21.1602 31.5241V21.8621L22.2532 20.769C23.6376 19.3846 25.8821 19.3846 27.2665 20.769C28.6466 22.1474 28.6546 24.3943 27.2665 25.7823Z'
      fill='#DB2556'
    />
  </svg>
)

export default arcmIcons
